export default "__VITE_ASSET__CJACWotI__"